import { gql } from '@/modes/admin/gql';
import { EmailType, PhoneType } from '../Profile/types';

export const GET_COMPANY = gql(`
  query Company($where: JSON) {
    companies(where: $where) {
      id
      name
      user {
        profileId
        email
      }
      backflowTester {
        created
      }
      waterSupplierIds
      waterSupplier {
        created
      }
      phones {
        id
        subType
        value
        extension
      }
      emails {
        id
        subType
        value
      }
      contactAddressId
      contactAddress {
        street1
        street2
        city
        state
        zip
        zipExt
      }
    }
  }
`);

export type Company = {
  id: string;
  name: string;
  user: {
    email: string;
  };
  backflowTester?: {
    created: number;
  };
  waterSupplierIds: string[];
  waterSupplier?: {
    created: number;
  };
  contactAddress?: {
    id: string;
    street1: string;
    street2: string;
    city: string;
    state: string;
    zip: string;
    zipExt: string;
  };
  phones: {
    id: string;
    subType: PhoneType;
    value: string;
    extension: string;
  }[];
  emails: {
    id: string;
    subType: EmailType;
    value: string;
  }[];
};
